import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import './contentBlock.html';
import './contentBlock.scss';

export interface ContentBlockVMConfig {
    title?: SubscribableOrNullableValue<string>
    content: SubscribableOrNullableValue<string>
    topicId?: SubscribableOrNullableValue<string>
    theme?: SubscribableOrNullableValue<ContentBlockVMTheme>
}

export type ContentBlockVMTheme = 'default' | 'rounded';

@injectable()
export default class ContentBlockVM {
    topicId: Subscribable<string | undefined>

    title: Subscribable<string>
    hasTitle: Subscribable<boolean>
    
    content: Subscribable<string>

    constructor(
        @inject(wccModules.componentConfig) config: ContentBlockVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.topicId = ko.flattenComputed(config.topicId);

        this.title = ko.flattenComputed(config.title, '');
        this.hasTitle = ko.pureComputed(() => this.title().length > 0);

        this.content = ko.flattenComputed(config.content, '');

        const theme = ko.flattenComputed(config.theme, 'default');

        const isReady = ko.pureComputed(() => this.content().length > 0);

        ko.applyBindingsToNode(info.element, {
            'visible': isReady,

            'css': {
                'content-block': true,
                'content-block--rounded': theme.is('rounded')
            }
        });
    }
}